import { isDevelopment } from "appConfiguration";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import {
  useAppConfiguration,
  useIsPitstopConfiguration,
} from "core/context/AppConfigurationContext";
import type { ReactNode } from "react";

export function ConfigCheckWrapper({
  children,
  skip = false,
}: {
  children: ReactNode;
  skip?: boolean;
}) {
  const config = useAppConfiguration();
  const isPitstop = useIsPitstopConfiguration();
  let requiredKeys = ["API_URL", "APPLICATIONINSIGHTS_CONNECTION_STRING"];
  if (isPitstop) {
    requiredKeys = [
      "API_URL",
      "IDS_URL",
      "CENTRIX_URL",
      "APPLICATIONINSIGHTS_CONNECTION_STRING",
      "GOOGLE_EMBED_API_KEY",
      "NPS_REDIRECT_URL",
      "V7_REDIRECT_URL",
      "SUPPORT_EMAIL",
      "NOVUSGLASS_REDIRECT_URL",
      "SPEEDYAUTO_REDIRECT_URL",
      "FIXAUTO_REDIRECT_URL",
      "NPS_CRE_REDIRECT_URL",
      "NPS_FIXAUTO_REDIRECT_URL",
      "NEXT_PUBLIC_MUI_X_LICENSE",
      "NEXT_PUBLIC_RECAPTCHA_SITE_KEY",
      "V7_CRE_REDIRECT_URL",
      "V7_PROC_REDIRECT_URL",
      "NEXT_PUBLIC_SHAREPOINT_URL",
      "NEXT_PUBLIC_MSAL_AUTHORITY",
      "NEXT_PUBLIC_MSAL_CLIENT_ID",
      "NEXT_PUBLIC_MSAL_REDIRECT_URI",
      "NEXT_PUBLIC_LOGO_BASE_URL",
    ];
  } else {
    requiredKeys = [
      ...requiredKeys,
      "NEXT_PUBLIC_RECAPTCHA_SITE_KEY",
      "NEXT_PUBLIC_LOGO_BASE_URL",
    ];
  }
  const missingConfigs = requiredKeys.filter(
    (key) => !config[key as keyof typeof config]
  );
  if (isDevelopment || skip) {
    return <>{children}</>;
  }
  if (missingConfigs.length === 0) {
    return <>{children}</>;
  }
  return (
    <Container maxWidth="lg">
      <Box component="main" paddingY={2}>
        <Typography variant="h4" color="error.main">
          The following environment variable have not been configured:
        </Typography>
        <ul>
          {missingConfigs.map((variable) => (
            <li key={variable}>
              <strong>{variable}</strong>
            </li>
          ))}
        </ul>
      </Box>
    </Container>
  );
}
